import React, { useState } from "react";
import Modal from "react-responsive-modal";
import ModalAddStaff from "root/Modals/ModalAddStaff";

const useModalAddStaff = () =>
{
    const [dialog, setDialog]  = useState ( { openState: false, provider_id: null, mode: null, user_id: null, onSaveCompleted: null })   ;

    const onClick = ( provider_id, user_id, mode, onCompleteFunction ) =>
    {
        setDialog ({ openState: true, provider_id: provider_id, user_id: user_id, mode: mode, onSaveCompleted: onCompleteFunction });
    }

    const onCloseModal = () =>
    {
        // Tell the parent we're done
        if ( dialog.onSaveCompleted != null )
        {
            dialog.onSaveCompleted('cancel') ;
        }

        setDialog ({ openState: false, provider_id: null, user_id: null, mode: null, onSaveCompleted: null });
    };

    const onSaveComplete = () =>
    {
        // Tell the parent we're done
        if ( dialog.onSaveCompleted != null )
        {
            dialog.onSaveCompleted('saved') ;
        }

        // Close the dialog
        setDialog ({ openState: false, provider_id: null, user_id: null, mode: null, onSaveCompleted: null });

    };

    const render = () =>
    {
        return (
            <Modal center focusTrapped={false} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                <ModalAddStaff onSaveCompleted={onSaveComplete} onClose={onCloseModal} provider_id={dialog.provider_id} user_id={dialog.user_id} params={dialog} mode={dialog.mode} />
            </Modal>
        )
    }

    return [ render, onClick ] ;
}

export default useModalAddStaff ;
